import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeRadius } from "styles/appThemeTokens";

const uiFont = appThemeFonts.family.ui;

export const StyledDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    borderRadius: appThemeRadius.lg,
    fontFamily: uiFont,
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingRight: 8,
  fontFamily: uiFont,
  fontSize: 16,
  fontWeight: 700,
  color: appThemeColors.text.heading,
}));

export const StyledDialogContent = styled(DialogContent)(() => ({
  paddingTop: 8,
  minHeight: 320,
  maxHeight: "70vh",
  fontFamily: uiFont,
}));

export const SearchFieldWrap = styled(Box)({
  marginBottom: 16,
});

export const CurrentValueText = styled(Typography)(() => ({
  marginBottom: 8,
  fontFamily: uiFont,
  fontSize: "12.5px",
  color: appThemeColors.text.muted,
}));

export const TreeScrollBox = styled(Box)(() => ({
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: appThemeColors.border.default,
  borderRadius: appThemeRadius.md,
  maxHeight: 360,
  overflow: "auto",
  fontFamily: uiFont,
}));

export const EmptyTreeText = styled(Typography)(() => ({
  padding: 16,
  fontFamily: uiFont,
  fontSize: "12.5px",
  color: appThemeColors.text.muted,
}));

export const HintText = styled(Typography)(() => ({
  marginTop: 8,
  fontFamily: uiFont,
  fontSize: "11.5px",
  color: appThemeColors.text.muted,
}));

